export const initializeProfitwell = user => {
  if (process.env.TESTING_PROFITWELL || process.env.NODE_ENV === 'production') {
    window.profitwell('start', {
      user_email: user.email,
    })
  }
}
